import script from "./Fingerprint.vue?vue&type=script&setup=true&lang=ts"
export * from "./Fingerprint.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__